import { useContext, useState, useEffect } from 'react';

import { AtlasEventsContext } from '@atlas/contexts/events';

import { LatLngTuple } from '@typings/geo';

export const usePosition = () => {
  const { on } = useContext(AtlasEventsContext);
  const [position, setPosition] = useState<GeolocationPosition>();

  useEffect(() => {
    let watcherId: number;
    on('locationAccessGranted', (pos) => {
      setPosition(pos);
      watcherId = navigator.geolocation.watchPosition((pos) =>
        setPosition(pos),
      );
    });
    return () => {
      if (watcherId || watcherId === 0)
        navigator.geolocation.clearWatch(watcherId);
    };
  }, [setPosition]);

  return {
    position,
    formattedCoordinates:
      position &&
      ([position.coords.latitude, position.coords.longitude] as LatLngTuple),
  };
};
